import { useCallback } from "react";
import Button from "../Button";
import { useI18n } from "../../hooks/i18n-hooks";
import { RNSwipeButtonProps } from "./SwipeButton";
import { useSetAlert } from "../../hooks/use-set-alert";

export const SwipeButton = ({
    title = "",
    onSwipeSuccess,
    disabled,
    mode,
    ...props
}: RNSwipeButtonProps) => {
    const { setAlert } = useSetAlert();
    const i18n = useI18n();

    const onPressButton = useCallback(() => {
        setAlert({
            title,
            message: i18n.t("confirm_question"),
            buttons: [
                {
                    text: i18n.t("yes"),
                    onPress: () => {
                        if (onSwipeSuccess) {
                            void onSwipeSuccess();
                        }
                    },
                    style: "default",
                },
                {
                    text: i18n.t("cancel"),
                    style: "cancel",
                },
            ],
            options: { cancelable: true },
        });
    }, [i18n, onSwipeSuccess, setAlert, title]);

    return (
        <Button
            onPress={onPressButton}
            disabled={disabled}
            buttonMode={mode}
            label={title}
            {...props}
        />
    );
};
